import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { IonIcon, IonItemOptions, IonItemOption, IonItemSliding } from '@ionic/vue';
import { addCircleOutline, trashOutline } from 'ionicons/icons';
import { IScannedArticle } from '@/const/types/article';

import ArticleQuantityCardBase from './ArticleQuantityCardBase.vue';

interface Props {
    article: IScannedArticle;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ArticleQuantityCardSliding',
  props: {
    article: null
  },
  emits: ["deleteSingleArticle", "openChangeQuantityAlert"],
  setup(__props: any, { emit }: { emit: ({
    (e: 'deleteSingleArticle'): void
    (e: 'openChangeQuantityAlert'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    article: IScannedArticle;
};





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonItemSliding), null, {
    default: _withCtx(() => [
      _createVNode(ArticleQuantityCardBase, {
        article: props.article
      }, {
        right: _withCtx(() => [
          _renderSlot(_ctx.$slots, "right")
        ]),
        _: 3
      }, 8, ["article"]),
      _createVNode(_unref(IonItemOptions), { side: "end" }, {
        default: _withCtx(() => [
          _createVNode(_unref(IonItemOption), {
            color: "success",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('openChangeQuantityAlert')))
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonIcon), {
                slot: "icon-only",
                icon: _unref(addCircleOutline)
              }, null, 8, ["icon"])
            ]),
            _: 1
          }),
          _createVNode(_unref(IonItemOption), {
            color: "danger",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('deleteSingleArticle')))
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonIcon), {
                slot: "icon-only",
                icon: _unref(trashOutline)
              }, null, 8, ["icon"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 3
  }))
}
}

})